import { Formik } from "formik";
import React, { useCallback, useState } from "react";
import { AiOutlineLock } from "react-icons/ai";
import { IoMdArrowForward } from "react-icons/io";
import { toast } from "react-toastify";
import * as Yup from "yup";
import ContainedButton from "components/layout/form/containedButton";
import TextField from "components/layout/form/textField";
import api from "services/api";
import { useMediaQuery } from "react-responsive";
import { passwordRegex } from "utils/regex";
import { HeaderContainer } from "../styles";
import CustomToolip from "./CustomToolip";
import PasswordForceMobile from "./PasswordForceMobile";
import {
  Container,
  ContainerButtons,
  ContainerForm,
  FormContainer,
  Field,
  WrapSearchDocument,
  SearchDocumentText,
  SearchDocumentIcon,
} from "./styles";
import { requestGetAccessToken } from "../utils";

const Activation = ({ setStep, userInfo }) => {
  const [loading, setLoading] = useState(false);
  const [showPasswordForce, setShowPasswordForce] = useState(false);

  const showMobileMode = useMediaQuery({ maxWidth: 959 });

  const validationSchema = () =>
    Yup.object().shape({
      password: Yup.string()
        .required("Insira uma senha")
        .matches(
          passwordRegex,
          "Use o mínimo de 8 caracteres, com uma combinação de letras maiúsculas, minúsculas, números e símbolos."
        ),
      passwordConfirmation: Yup.string()
        .required("Insira a confirmação de sua senha")
        .oneOf([Yup.ref("password"), null], "As senhas não combinam"),
    });

  const requestPatchUser = useCallback(
    async (passwordConfirmation, password) => {
      setLoading(true);
      toast.dismiss();
      const access_token = await requestGetAccessToken();
      const { userId } = userInfo;

      const headers = {
        access_token,
      };

      const body = {
        password,
        passwordConfirmation,
        token: userInfo?.token,
      };

      api
        .patch(`industrial/customer/v1/users/${userId}`, body, { headers })
        .then((res) => {
          const tokenMFA = res.headers["x-mfa-hash"];
          if (tokenMFA) {
            localStorage.setItem("@UltragazEmpresarial:X-Mfa-Hash", tokenMFA);
          }
          setStep(5);
        })
        .catch((error) => {
          setLoading(false);
          const erro = error.response;
          if (erro) {
            const message = error.response.data.message;
            if (error.response.status !== 401) {
              toast.error(message);
            }
          } else {
            if (error.response.status !== 401) {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          }
        });
    },
    [api, userInfo, toast]
  );

  const handleSubmit = useCallback(
    async ({ passwordConfirmation, password }) => {
      if (!loading) {
        requestPatchUser(passwordConfirmation, password);
      }
    },
    [requestPatchUser, loading]
  );

  const handleShowPasswordForce = useCallback(() => {
    setShowPasswordForce(!showPasswordForce);
  }, [showPasswordForce]);

  return (
    <Container>
      <HeaderContainer>
        <h1>Cadastrar nova senha</h1>
        <h2>Lembre de atender os requisitos de segurança</h2>
      </HeaderContainer>

      <Formik
        initialValues={{
          password: "",
          passwordConfirmation: "",
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={validationSchema}
        render={({ handleChange, handleBlur, values, errors, touched }) => (
          <FormContainer>
            <ContainerForm>
              <Field>
                <TextField
                  id="password"
                  name="password"
                  label="Senha"
                  aria-label="Senha"
                  aria-required
                  errorCondition={errors.password && touched.password}
                  errorMessage={errors.password}
                  showChangeTextPassword={true}
                  onBlur={handleBlur}
                  placeholder="Senha"
                  value={values.password}
                  onChange={handleChange}
                  LeadingIcon={() => <AiOutlineLock />}
                />
                <WrapSearchDocument>
                  {!showMobileMode && (
                    <CustomToolip title="Requisitos de Senha">
                      <SearchDocumentText>
                        Requisitos de senha
                      </SearchDocumentText>
                      <SearchDocumentIcon>!</SearchDocumentIcon>
                    </CustomToolip>
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                    }}
                  >
                    {showMobileMode && (
                      <div
                        style={{
                          display: "flex",
                        }}
                        onClick={handleShowPasswordForce}
                      >
                        <SearchDocumentText>
                          Requisitos de senha
                        </SearchDocumentText>
                        <SearchDocumentIcon>!</SearchDocumentIcon>
                      </div>
                    )}

                    {showMobileMode && showPasswordForce && (
                      <PasswordForceMobile />
                    )}
                  </div>
                </WrapSearchDocument>
              </Field>

              <Field>
                <TextField
                  id="passwordConfirmation"
                  name="passwordConfirmation"
                  label="Confirmação de Senha"
                  aria-label="Confirmação de Senha"
                  aria-required
                  errorCondition={
                    errors.passwordConfirmation && touched.passwordConfirmation
                  }
                  errorMessage={errors.passwordConfirmation}
                  showChangeTextPassword={true}
                  onBlur={handleBlur}
                  placeholder="Confirme a senha"
                  value={values.passwordConfirmation}
                  onChange={handleChange}
                  LeadingIcon={() => <AiOutlineLock />}
                />
              </Field>
            </ContainerForm>

            <ContainerButtons>
              <ContainedButton
                type="submit"
                loading={loading}
                id="Avançar"
                width="100%"
                TrailingIcon={() => <IoMdArrowForward size={20} />}
              >
                Continuar
              </ContainedButton>
            </ContainerButtons>
          </FormContainer>
        )}
      />
    </Container>
  );
};

export default Activation;
